
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"124","height":"124"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#95989a","d":"M93 11.333H31c-5.707 0-10.333 4.627-10.333 10.334v82.666c0 5.707 4.626 10.334 10.333 10.334h34.927a15.503 15.503 0 0010.953-4.547l21.907-21.907a15.5 15.5 0 004.546-10.953V21.667c0-5.707-4.626-10.334-10.333-10.334zm0 62H67.167A5.167 5.167 0 0062 78.5v25.833H31V21.667h62v51.666zm-49.083-31h36.166a2.583 2.583 0 002.584-2.583v-5.167A2.584 2.584 0 0080.083 32H43.917a2.584 2.584 0 00-2.584 2.583v5.167a2.583 2.583 0 002.584 2.583zm0 20.667h20.666a2.584 2.584 0 002.584-2.583V55.25a2.583 2.583 0 00-2.584-2.583H43.917a2.583 2.583 0 00-2.584 2.583v5.167A2.584 2.584 0 0043.917 63z","fill-rule":"evenodd"}})])
          )
        }
      }
    